<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body" id="personnaliseproduct">
    <div class="product-infos">
        <h1 class="product-name">{{product.name}}</h1>
        <div *ngIf="product.sizes?.length>0 && product.size>=0">
            <span class="nb">
                <ng-container *ngIf="product.sizes[product.size].level">
                    {{product.sizes[product.size].size}}
                </ng-container>
            </span>
        </div>
    </div>
    <div *ngIf="loading" id="loadingPage"></div>
    <div class="all">
        <div class="compositions" *ngIf="product.id && !loading">
            <p class="unavailableIng" *ngIf="unavComp>0 || unavOpt>0 || unavSupp>0">
                <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                moment
            </p>
            <div class="gr-li" *ngIf="product.compositions?.length>0">
                <p class="p-par">
                    Compositions
                </p>
                <div class="d-grid">
                    <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                        id="wTooltipComp{{i}}">
                        <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text" [available]="comp.available"
                            placement="bottom" containerClass="customClass">
                        </onoffswitch>
                    </div>
                </div>
            </div>
            <div class="gr-li" *ngIf="product.maxNbrIngOptions>0">
                <p class="p-par">
                    <ng-container *ngIf="(product.optionIngredients|groupByCategory).length>1">
                        Options</ng-container>
                    <ng-container *ngIf="(product.optionIngredients|groupByCategory).length==1">
                        {{(product.optionIngredients|groupByCategory)[0].category}}</ng-container>
                    : {{product.maxNbrIngOptions}} max
                </p>
                <div class="text-gray" id="obligatoryIngredient" *ngIf="product.obligatoryIngredient.length>0">
                    <div class="d-flex" style="margin: 0px 0px 10px 0px">
                        <label class="d-block">Obligatoire</label>
                        <ul style="margin-left:10px">
                            <li *ngFor="let ing of product.obligatoryIngredient">
                                + {{ing.category}}
                                <ng-container *ngIf="ing.maxNbrIngOptions && ing.max2NbrIngOptions">: min
                                    {{ing.maxNbrIngOptions}} , max {{ing.max2NbrIngOptions}}
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
                <ul>
                    <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                        <p class="p-col" *ngIf="(product.optionIngredients|groupByCategory).length>1">
                            <b class="templateColor">Options » </b>{{c.category}} :
                            <ng-container *ngIf="c.minNbrIngOptions && c.maxNbrIngOptions">( min
                                {{c.minNbrIngOptions}} , max {{c.maxNbrIngOptions}} )
                            </ng-container>
                        </p>
                        <div class="d-grid">
                            <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                <onoffswitch (change)="changeOption(opt,c)" [(ngModel)]="opt.checked" [label]="opt.text"
                                    [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked) || (c.maxNbrIngOptions && c.optChecked==c.maxNbrIngOptions && !opt.checked)"
                                    [available]="opt.available">
                                </onoffswitch>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="gr-li" *ngIf="product.hasSupp>0">
                <p class="p-par">
                    <span>Supplément</span>
                </p>
                <ul>
                    <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                        <p class="p-col">
                            <b class="templateColor">Supp » </b>{{c.category}} :
                        </p>
                        <div class="d-grid">
                            <div class="check-group" *ngFor="let supp of c.elements;let i=index">
                                <onoffswitch [(ngModel)]="supp.checked" label="{{supp.text}} ( {{supp.price}} € )"
                                    [available]="supp.available" (change)="changeSupp()">
                                </onoffswitch>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div *ngIf="!loading" class="product-comment">
        <label>Commentaire : </label>
        <textarea name="comment" [(ngModel)]="product.comment" rows="3"></textarea>
    </div>
    <div class="d-flex footer" *ngIf="!loading">
        <div class="product-quantity vcenter">
            <div class="quantity">
                <button (click)="decrQty()">-</button>
                <p>{{product.qty}}</p>
                <button (click)="incrQty()">+</button>
            </div>
            <!-- <p class="total">Total : {{total}} €</p> -->
        </div>
        <button class="add-to-cart btn" (click)="addToBasket()">
            Total : {{total}} €
        </button>
    </div>
</div>